<template>
    <div class="container" v-loading="tableing">
        <div class="hat">
            <div class="header">{{allData.name}}</div>
            
            <div class="monitorDiv bLeftLine" v-if="youxunType">
                <p><img :src="exeLogin? statusOn:statusOff" alt="" srcset=""> 主</p>
                <p><img :src="appLogin? statusOn:statusOff" alt="" srcset=""> 副</p>
            </div>
            <el-button size="mini" class="examYxinfo" @click="examYxInfo()" v-if="youxunType">优巡登录信息</el-button>
            <!-- <span class="iconMail bLeftLine" @click="copyClick"><img src="../../../static/images/hiddenMail.png" alt="" srcset=""></span> -->
            <div class="examTime bLeftLine">剩余时间：{{dealExamMin(examMinTime)}}</div>
            <el-button class="exit bLeftLine" size="mini" @click="exit()"><img src="../../../static/images/end-back.png" alt="" srcset=""> &nbsp;退 出 </el-button>
        </div>
        <answer-sheet class="sheetClass" ref="answerSheet" :buttonNum="buttonNum" @flashTag="flashTag" @storeLocally="storeLocally"></answer-sheet>
        <div class="container-skin">
            <div class="main">
                <div class="mainStyle">
                    <el-carousel
                        ref="carousel"
                        trigger="click"
                        :initial-index="initIndex"
                        :autoplay="false"
                        :loop="false"
                        arrow="never" 
                        @change="onChange"
                        indicator-position="none" 
                        class="carouselItem"
                    >
                        <div v-for="(item,index) in topicList" :key="index">
                            <el-carousel-item v-for="(son,i) in item.questionList" :key="index+i">
                                <topic 
                                    :ref="'topicRef'+son.bId"
                                    :questionText="son"
                                    :serial="son.serial"
                                    :upFileName120="upFileName120"
                                    :allData="allData"
                                    @storeLocally="storeLocally"
                                    :allAnswer="allAnswer.length==0? undefined:allAnswer.dataList[son.serial-1]"
                                    :buttonNum="buttonNum"
                                    @come3Time="come3Time"
                                    :forced="forced"
                                    :examMinTime="examMinTime"
                                    :firstStartDateVal="firstStartDateVal"
                                    :uuid1="uuid1"
                                    :networkError="networkError"></topic>
                            </el-carousel-item>
                        </div>
                    </el-carousel>
                </div>
            </div>
            <div class="footer">
                <el-button class="upSub" v-show="buttonNum>1" @click="lastQuestion()">上一页</el-button>
                <el-button class="sub" :style="{width:(buttonNum>1? '20%':'30%')}" @click="nextQuestion()">{{`${buttonText} ${buttonNum}/${buttonTotal}`}}<span>页</span> </el-button>
            </div>
        </div>

        <el-dialog
            class="exitExam"
            title="确定提交结果"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <span style="font-size:18px">确认提交上传数据并保存本地数据？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit()" :disabled="preventDoubles">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 打谱题 倒计时 -->
        <el-dialog
            title="11"
            class="countdownBox"
            :visible.sync="countdownDialog"
            width="30%"
            :fullscreen="true"
            :modal-append-to-body="true"
            center>
            <div class="countdownBox-con">
                <p>{{threeSeconds}}</p>
                <p>倒计时结束后开始答题</p>
            </div>
        </el-dialog>

        <!-- 提交loading -->
        <el-dialog
            title="提交填报进度"
            class="lastBox"
            :visible.sync="submitTheCircle"
            width="30%"
            :close-on-click-modal="false"
            :show-close="false"
            center>
            <div class="lastBox-con">
                <!-- <div class="hader">交卷进度</div> -->
                <div class="styleUpdate">
                    <div class="stu-name">数据备份：</div>
                    <div class="stu-load" :style="{width:(backupStatus=='上传失败'? '48%':'60%')}"><el-progress :text-inside="true" :stroke-width="18" :percentage="$store.getters.is_textRess" :color="customColor"></el-progress></div>
                    <div class="stu-last" :style="{color:(backupStatus=='上传中'? '#000':backupStatus=='待上传'? '':backupStatus=='已上传'? 'green':backupStatus=='上传失败'? 'red':''),width:(backupStatus=='上传失败'? '17%':'20%')}">{{backupStatus}}</div>
                    <div class="stu-agian" v-if="backupStatus=='上传失败'">
                        <el-button type="primary" v-if="backupStatus=='上传失败'" @click="axjsOss()" class="closeBtu" size="mini"> 重新上传 </el-button>
                    </div>
                </div>
                <div class="styleUpdate">
                    <div class="stu-name">提 交：</div>
                    <div class="stu-load" :style="{width:(percenStatus=='上传失败'? '48%':'60%')}"><el-progress :text-inside="true" :stroke-width="18" :percentage="theirPapers" :color="customColor"></el-progress></div>
                    <div class="stu-last" :style="{color:(percenStatus=='上传中'? '#000':percenStatus=='待上传'? '':percenStatus=='已上传'? 'green':percenStatus=='上传失败'? 'red':''),width:(percenStatus=='上传失败'? '17%':'20%')}">{{percenStatus}}</div>
                    <div class="stu-agian" v-if="percenStatus=='上传失败'">
                        <el-button type="primary" v-if="percenStatus=='上传失败'" @click="axjsJj()" class="closeBtu" size="mini"> 重新上传 </el-button>
                    </div>
                </div>
                <div class="food">
                    <el-button type="success" @click="successExam" size='mini' class="succExam"
                    :disabled="!(percenStatus=='已上传'&&backupStatus=='已上传')"
                    > 填报完成 </el-button>
                </div>
                <div class="downTxt">
                    <el-link type="primary" class="downTxt_btu" @click="downloadToLocal" :disabled="!storageJson">下载填报数据到本地</el-link>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog
            title="提 示"
            :visible.sync="dialogSwitch"
            width="30%"
            class="switchingBrowsers">
            <span style="font-size:17px;font-weight: bold;"> <i class="el-icon-warning" style="color:#e6a23c;font-size: 20px;"></i> 考试中请勿在浏览器中切换网页或打开其他网页</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogSwitch = false" size="mini" style="width:90px;">确 定</el-button>
            </span>
        </el-dialog>

        <exam-all-ok ref="examAllOk" @mandatoryAjax="mandatoryAjax" @editAnswerType="editAnswerType"></exam-all-ok>
        <exam-time-to ref="examTimeTo" @autoSubmit="autoSubmit"></exam-time-to>
        <you-xun-drops ref="youXunDrops" :appLogin="appLogin" :exeLogin="exeLogin"  @getLoginStatus="getLoginStatus"></you-xun-drops>
        <prompt-mailbox ref="promptMailbox"></prompt-mailbox>
    </div>
</template>
<script>
import topic from '../../components/exam/topic'
import examAllOk from '../../components/exam2/examAllOk'
import examTimeTo from '../../components/exam2/examTimeTo'
import youXunDrops from '../../components/exam2/youXunDrops'
import answerSheet from './answerSheet'
import utils from '../../lib/util'
import store from '../../vuex/store'
import os from '../../lib/oss'
import { loginStatus,getDateNow } from '../../lib/youxunAPI';
import systemCheck from '../../lib/systemCheck'
import AES from '../../lib/encryption'
import zipOss from '../../lib/zipOss'
import wsMethod from '../../lib/socketMethod'

    export default {
        name:"problem",
        data() {
            return {
                tableing:false,
                centerDialogVisible:false,
                countdownDialog:false,
                submitTheCircle:false,
                dialogSwitch:false,
                preventClickTime:false,
                preventTimeout:null,
                allData:{},
                topicList:[],
                progress:1,
                buttonTotal:1,
                buttonNum:1,
                initIndex:0,
                endDateVal:'',
                startDateVal:'',
                firstStartDateVal:'',
                upTopic:true,
                topicType:['10','11','12','20','30','50','60','61','91','110','150','170'],
                keYimarking:['10','11','12','50'],
                timer:'',
                time5min:'',
                examMinTime:-1,
                switchNum:0,
                flegF12:true,// 是否禁止刷新/F2,
                allAnswer:[],
                isSubmit:false,
                threeSeconds:3,
                uid:this.$base64.decode(window.localStorage.getItem('uid-web')),
                usermsg:this.$base64.decode(window.localStorage.getItem('usermag-web')),
                theirPapers:0,
                backupStatus:'上传失败',
                percenStatus:'',//待上传 上传中 已上传 上传失败
                storageJson:'',
                preventDoubles:false,
                customColor:'#1D4BB0',
                appLogin:false,
                exeLogin:false,
                youxunType:false,
                youxunTimeout:'',
                networkError:false,
                isNewWork:'',
                statusOn:require("../../../static/images/moning-on.png"),
                statusOff:require("../../../static/images/moning-off.png"),
                upFileName120:'',//试卷名称+考试号+姓名+准考证号+题号.zip
                uuid1:'',
                ENDTIME:'',//考试结束时间，考试自动结束的唯一依据
                ws:'',
                mqttClient:'',
                qieTidelayWs:null,
                // 控制添加静态页面
                forced:[],
                forced1:[{
                        name:'九年级音乐网络测试卷一',
                        nine:[//第几部分的位置
                            {val:[0,3,7,9,11]},
                            {val:[0,0,3]}
                        ],
                        insertAdd:[0,4,9,12,15,18,19,23],
                        sslName:'91'
                    },{
                        name:'九年级音乐网络测试卷二',
                        nine:[
                            {val:[0,3,7,9,11]},
                            {val:[0,0,3]}
                        ],
                        insertAdd:[0,4,9,12,15,18,19,23],
                        sslName:'92'
                    },{
                        name:'考前测试',
                        nine:[
                            {val:[0]},
                            {val:[0]}
                        ],
                        insertAdd:[0,5],
                        sslName:'93'
                    },{
                        name:'全球音乐艺考能力测评',
                        nine:[
                            {val:[0,0,10]}
                        ],
                        insertAdd:[0,1,12],
                        sslName:'94'
                    }
                ],
            }
        },
        components:{
            topic,
            examAllOk,
            examTimeTo,
            answerSheet,
            youXunDrops,
        },
        created(){
            wsMethod.socketCreate(this)
        },
        watch: {
            'examMinTime':function(now,old){
                //距离考试结束还有10分钟/5分钟，请尽快完成答题。提示
                if(now == 660||now == 360){
                    this.$notify({
                        title: '提示',
                        message: `距离资料上传结束还有${now==660?'10':'5'}分钟，请尽快完成上传作品。`,
                        customClass:'importentTitle',
                        position: 'top-left',
                        type: 'warning',
                        duration: 0,
                    });
                }
            },
            'buttonNum':{
                handler: function(now,old) {
                    const that = this
                    that.qieTidelayWs && window.clearTimeout(that.qieTidelayWs)
                    that.qieTidelayWs = window.setTimeout(function(){
                        window.localStorage.setItem('buttonNum',now)
                        wsMethod.wsSend211(that)
                    },150)
                },
                immediate: true
            }
        },
        computed:{
            buttonText: function () {
                let t = ''
                let nowNum = []
                this.forced.some(item=>{
                    if(this.allData.name&&(this.allData.name.trim()==item.name.trim()||this.allData.name.trim()==item.name.trim())){
                        item.insertAdd.forEach((elem, index) => {
                           nowNum.push(elem+1)
                        })
                        return true;
                    }
                })
                this.buttonTotal == this.buttonNum? t ='提交':nowNum.indexOf(this.buttonNum) == -1? t ='下一页':t ='下一页'
                return t
            },
        },
        beforeDestroy() {
            // 解除禁止F12
            this.flegF12 = true
            window.addEventListener('keydown',this.listenerHandle,false)
            // 解除刷新阻止
            window.onbeforeunload = function(e) {
                return;
            };
            if(!this.isSubmit){
                this.storeLocally()
            }
            window.clearInterval(this.youxunTimeout)
            this.isNewWork && window.clearInterval(this.isNewWork)
            this.timer && window.clearTimeout(this.timer)
            this.time5min && window.clearTimeout(this.time5min);
            this.ws && this.ws.wsClose()
            wsMethod.cloneXT()
            this.qieTidelayWs && window.clearTimeout(this.qieTidelayWs)
            this.preventTimeout && window.clearTimeout(this.preventTimeout)
        },
        destroyed() {
            // 解除禁止右键
            document.oncontextmenu = function(){
                return true;
            }
            this.judgeZipLoading()
        },
        mounted(){
            let that = this
            // 禁止右键
            document.oncontextmenu = function(){
                return false;
            }
            // 禁止F12
            that.flegF12 = false
            window.addEventListener('keydown',that.listenerHandle,false)
            // 刷新阻止
            window.onbeforeunload = function(e) {
                if(!that.isSubmit){
                    that.storeLocally()
                }
                var dialogText = '禁止刷新';
                e.returnValue = dialogText;
                return dialogText;
            };
            that.$nextTick(()=>{
                that.getNetWorkTime((time)=>{
                    that.formalToLastUuid(function(){
                        that.startDateVal = time
                        that.firstStartDateVal = time
                        that.uuid1 = utils.uuid2(32)
                        that.buriedPointEventAdd()
                        that.getAjaxJsonUrl()
                        that.addUdeskCn()
                    })
                })
                // 如果接入优巡试卷，开启优巡登陆状态检查
                that.youxunType = that.$route.query.youXunExamNum? true:false
                if(that.youxunType) that.getLoginStatus()//
            })

            // 答题计时器、切换浏览器标签页
            if (document.hidden !== undefined) {
                document.onvisibilitychange=function(){
                    if(document.visibilityState=="visible"){//回来
                        if(that.$store.state.isSwitch) {that.$store.commit('get_isSwitch',false);return}
                        //只限定在problem考试页面
                        if(window.location.href.indexOf('/problem?')>=0){
                            if(that.examMinTime<=0) return
                            that.setTimer5Minutes()
                            that.switchNum++;
                            that.storeLocally();
                            // that.dialogSwitch = true
                        }
                    }else{//离开
                        if(that.$store.state.isSwitch) return
                        //只限定在problem考试页面
                        if(window.location.href.indexOf('/problem?')>=0){
                            if(that.examMinTime<=0) return
                            that.timer && window.clearTimeout(that.timer)
                            that.time5min && window.clearTimeout(that.time5min)
                        }
                    }
                }
            }
        },
        methods:{
            // 判断toLastUuid 是否是从列表也进入的
            formalToLastUuid(callback){
                let isAudit = true
                let toLastUuid_ = window.sessionStorage.getItem('toLastUuid')
                if(toLastUuid_&&this.$route.query.userSignId&&this.$route.query.bId){
                    let toLastUuid_array = toLastUuid_.split('-')
                    if(this.$route.query.bId!=toLastUuid_array[0]||this.$route.query.userSignId!=toLastUuid_array[1]){
                        isAudit = false
                    }
                }else{
                    isAudit = false
                }
                // 表明非列表进入，退出重新进入
                if(!isAudit){
                    let that = this
                    that.timer && window.clearTimeout(that.timer);
                    that.time5min && window.clearTimeout(that.time5min);
                    that.youxunTimeout && window.clearInterval(that.youxunTimeout);
                    window.sessionStorage.removeItem('toLastUuid')
                    that.$notify({
                        type:'warning',
                        title: '提示',
                        message: '请从填报列表进入填报！'
                    });
                    that.$router.push({
                        path: '/myExamList'
                    })
                }else{
                    return callback()
                }
            },
            getNetWorkTime(callback){
                var timestamp2;
                getDateNow(function(response){
                    if((JSON.stringify(response) != '{}')&&response.data&&response.data.code == 0){
                        let nTime = response.data.data.sysTime
                        let pcTime = new Date().getTime();
                        let poorTime = nTime - pcTime;
                        let poorVal = 0;
                        if(Math.abs(poorTime)>=60000){ poorVal = poorTime }
                        localStorage.setItem('poorVal',poorVal);

                        timestamp2 = Number(response.data.data.sysTime)
                    }else{
                        let poorTime = window.localStorage.getItem('poorVal')
                        timestamp2 = Date.parse(new Date());
                        if(Number(poorTime)>=0){timestamp2 = Number(timestamp2) + Number(poorTime)}
                        else{timestamp2 = Number(timestamp2) - Number(Math.abs(poorTime))}
                    }
                    callback(utils.fmtDate(new Date(timestamp2),'yyyy-MM-dd hh:mm:ss'))
                })
            },
            // 判断考试结束时间和当前时间+时长
            judgeexamMinAndEndexamDate(examMin1=-1,callback){
                // 不管考试时长，（考试开始时间 至 考试结束时间）内任意答题 
                examMin1 = -1
                let that = this
                let nowTimestamp = Date.parse(new Date(that.startDateVal.replace(/-/g, "/")));//考试开始时间戳
                let endTimeDate = that.allData.examEndDate//考试结束时间戳
                let nowAddexamMin = (nowTimestamp+(examMin1*1000)) //当前时间加考试时长
                // 当前时间+时长 > 考试结束时间 ，则以考试结束时间为准，否则反之
                if((nowAddexamMin>=endTimeDate)||examMin1<=-1){
                    this.ENDTIME = nowTimestamp+(endTimeDate - nowTimestamp)
                    callback((endTimeDate - nowTimestamp)/1000)
                }else{
                    this.ENDTIME = nowTimestamp+(examMin1*1000)
                    callback(examMin1)
                }
            },
            listenerHandle(e){//禁止F11/F12/tab键
                if((e.keyCode > 111 && e.keyCode < 124)|| e.keyCode == 9){
                    if(window.event){
                        try{
                            e.keyCode = 0;
                        }
                        catch(e){}
                        e.returnValue = this.flegF12;
                    }else{
                        e.preventDefault();
                    }
                }
            },
            getAjaxJsonUrl(){
                let that = this
                wsMethod.wsSend204()
                that.tableing = true
                that.$axios.post('/paper/last/userSignInfo',{
                    userSignId:that.$route.query.userSignId,//报名id 获取抽题正式考试的题
                    paperId:that.$route.query.bId,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    let v = res.data;
                    if (v.code == 0) {
                        if(v.data.jsonUrl){
                            wsMethod.wsSend206()
                            that.getData(v.data.jsonUrl)
                            .then(()=>{})
                            .catch(()=>{
                                that.tableing = false;
                            })
                        }else{
                            that.tableing = false;
                            that.$notify.error({
                                title: '提示',
                                message: '当前试卷没有可答的题！'
                            });
                            that.$router.go(-1)
                        }
                    }else{
                        that.tableing = false;
                        wsMethod.wsSend207()
                        if(v.msg)
                        that.$message.error(v.msg);
                        else
                        that.$notify.error({
                            title: '提示',
                            message: '网络不佳，请重试！'
                        });
                        that.$router.go(-1)
                    }
                })
            },
            getData(jsonUrl){
                let that = this
                return new Promise((resolve, reject) => {
                    var xhr = new XMLHttpRequest();
                    xhr.open('get',jsonUrl,true);
                    xhr.send();
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState == 4&&xhr.status == 200){
                            if(xhr.responseText){
                                let responseData = JSON.parse(xhr.responseText)
                                if (responseData.groupList) {
                                    that.allData['bId'] = that.$route.query.bId
                                    that.allData['name'] = that.$route.query.paperName
                                    that.allData['examMin'] = that.$route.query.examMin
                                    that.allData['reviewType'] = that.$route.query.reviewType
                                    that.allData['examStartDate'] = that.$route.query.examStartDate
                                    that.allData['examEndDate'] = that.$route.query.examEndDate
                                    that.allData['groupList'] = responseData.groupList
                                    that.allData['paperVer'] = responseData.paperVer
                                    /**
                                     * 文件题上传自动生成文件名
                                     * 考级：试卷名称_考试号_姓名_准考证号_题号.zip
                                     * 评测：试卷名称_姓名_登录账号_题号.zip
                                    */
                                    let person_ = that.$route.query.personNum? `${that.$route.query.personNum}_`:'' 
                                    that.upFileName120 = `${that.allData.name}_${person_}${that.$route.query.idName}_${that.$route.query.ticketNum}`
                                    // 只有试卷没有题
                                    if(that.allData.groupList&&that.allData.groupList.length<=0){
                                        that.$notify.error({
                                            title: '提示',
                                            message: '当前试卷没有可答的题！'
                                        });
                                        that.$router.go(-1)
                                    }
                                    // if(that.allData.examMin>=0){
                                        that.judgeexamMinAndEndexamDate((that.allData.examMin*60),
                                        (value)=>{
                                            that.examMinTime = value
                                            that.setTimer5Minutes();
                                        })
                                    // }
                                    // 死页面占位
                                    for (let nx = 0; nx < that.forced.length; nx++) {
                                        if(that.allData.name.trim()==that.forced[nx].name.trim()){ 
                                            for (let i= 0; i < that.forced[nx].nine.length; i++) {
                                                let di = 0
                                                that.forced[nx].nine[i].val.forEach(ssl => {
                                                    that.allData.groupList[i].questionList.splice(ssl+di, 0, {
                                                        bId: 1,
                                                        questionDto: {
                                                            typeCode:777,
                                                            location:that.jisuanLoc(that.allData,i,ssl,di),
                                                            question:'',
                                                            sslName:that.forced[nx].sslName,
                                                        },
                                                        questionId: '',
                                                        questionVer: '',
                                                        score: '',
                                                        submitNum: '',
                                                    });     
                                                    di++;
                                                });
                                            }
                                            break;
                                        }
                                    }
    
                                    let tempLocalData1 = localStorage.getItem('ceping-'+that.uid+'-'+that.allData.bId)? JSON.parse(localStorage.getItem('ceping-'+that.uid+'-'+that.allData.bId)):[]
                                    // 驳回重传首次进入
                                    if(that.$route.query.bohuiChongchuan==1 && tempLocalData1.length<=0){
                                        that.bohuiChongchuanFirstGo()
                                        .then((txtData)=>{
                                            let b = 1
                                            that.topicList = that.allData.groupList.map((item)=>{
                                                item.questionList = item.questionList.map((results)=>{
                                                    results['serial'] = b;
                                                    that.buttonTotal = b;
                                                    b++;
                                                    return results
                                                })
                                                return item
                                            })
                                            that.$refs.answerSheet.passData(that.topicList)

                                            console.log('--驳回重传--')
                                            that.allAnswer = txtData
                                            if((that.allAnswer&&that.allAnswer.time)||(that.allAnswer&&that.allAnswer.time==0)){
                                                that.judgeexamMinAndEndexamDate(that.allAnswer.time,
                                                (value)=>{
                                                    that.$set(that,'examMinTime',value)
                                                })
                                            }
                                            if(that.allAnswer&&that.allAnswer.firstStartDateVal){
                                                that.$set(that,'firstStartDateVal',that.allAnswer.firstStartDateVal)
                                            }
                                            if(that.allAnswer&&that.allAnswer.switchNum){
                                                that.$set(that,'switchNum',that.allAnswer.switchNum)
                                            }
                                            wsMethod.wsSend209(that)
            
                                            // 如有文字体开启网络检查,上传文件需要保持网络流畅
                                            if(!that.youxunType){
                                                for (let cx = 0; cx < that.allData.groupList.length; cx++) {
                                                    const element = that.allData.groupList[cx];
                                                    for (let cx1 = 0; cx1 < element.questionList.length; cx1++) {
                                                        if(element.questionList[cx1].questionDto.typeCode == '120'){
                                                            that.isNetWork()
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            resolve()
                                        }).catch(()=>{resolve()})
                                    }else{//非驳回重传进入
                                        let b = 1
                                        that.topicList = that.allData.groupList.map((item)=>{
                                            item.questionList = item.questionList.map((results)=>{
                                                results['serial'] = b;
                                                that.buttonTotal = b;
                                                b++;
                                                return results
                                            })
                                            return item
                                        })
                                        that.$refs.answerSheet.passData(that.topicList)
                                        console.log('==取缓存==')
                                        that.allAnswer = tempLocalData1
                                        if((that.allAnswer&&that.allAnswer.time)||(that.allAnswer&&that.allAnswer.time==0)){
                                            that.judgeexamMinAndEndexamDate(that.allAnswer.time,
                                            (value)=>{
                                                that.$set(that,'examMinTime',value)
                                            })
                                        }
                                        if(that.allAnswer&&that.allAnswer.firstStartDateVal){
                                            that.$set(that,'firstStartDateVal',that.allAnswer.firstStartDateVal)
                                        }
                                        if(that.allAnswer&&that.allAnswer.switchNum){
                                            that.$set(that,'switchNum',that.allAnswer.switchNum)
                                        }
                                        wsMethod.wsSend209(that)
        
                                        // 如有文字体开启网络检查,上传文件需要保持网络流畅
                                        if(!that.youxunType){
                                            for (let cx = 0; cx < that.allData.groupList.length; cx++) {
                                                const element = that.allData.groupList[cx];
                                                for (let cx1 = 0; cx1 < element.questionList.length; cx1++) {
                                                    if(element.questionList[cx1].questionDto.typeCode == '120'){
                                                        that.isNetWork()
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        resolve()
                                    }
                                }else{
                                    reject()
                                }
                            }else{
                                reject()
                            }
                        }else{
                            reject()
                        }
                    }
                })

            },      
            // 驳回重传首次进入获取提交数据
            bohuiChongchuanFirstGo(){
                let that = this
                const ossBjArt = 'https://aitestgo-bj-art.oss-cn-beijing.aliyuncs.com'
                let answerUrl = `${ossBjArt}/${process.env.ANSWER_OSS}/${that.allData.bId}/${that.$route.query.userSignId}/answer.txt`
                console.log('驳回获取上次数据',answerUrl)
                return new Promise((resolve, reject) => {
                    var xhr = new XMLHttpRequest();
                    xhr.open('get',answerUrl,true);
                    xhr.send();
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                try {
                                    let responseData = JSON.parse(xhr.responseText)
                                    let storageData = []
                                    let arr = JSON.parse(responseData.jsonData)
                                    for (let i = 0; i < arr.length; i++) {
                                        storageData.push({
                                            submitNum:-1,
                                            obj:arr[i]
                                        })
                                    }
                                    let txtData = {
                                        firstStartDateVal: that.startDateVal,
                                        time: that.examMinTime,
                                        switchNum: that.switchNum,
                                        dataList: storageData,
                                    }
                                    resolve(txtData)
                                } catch(e){
                                    reject()
                                }
                            } else {
                                reject()
                            }
                        }
                    }
                })
            },
            jisuanLoc(v,i,ssl,di){
                let be = 0;
                for (let c = 0; c < i; c++) {
                    be += v.groupList[c].questionList.length
                }
                return be+ssl+di
            },
            nextQuestion(){
                let that = this
                try {
                    that.topicList.forEach((element,index) => {
                        element.questionList.forEach((ele,i) => {
                            let first = JSON.stringify(that.$refs.carousel.activeIndex)
                            let x = JSON.parse(first)
                            if(ele.serial == x+1){
                                // if(eval("that.$refs.topicRef" +(ele.bId))[0].whetherAnswer()){//是否已答题
                                    // 切换下一题，结束上一题音频 60 
                                    if(that.topicType.indexOf(ele.questionDto.typeCode)!=-1){eval("that.$refs.topicRef" +(ele.bId))[0].endAudio()}
                                    // 如果是最后一题》提交
                                    if(that.buttonNum == that.buttonTotal){
                                        setTimeout(()=>{
                                            that.okYesSubmit()
                                        },500)
                                        throw new Error("breakForEach");
                                    }
                                    that.$refs.carousel.next()
                                    that.buttonNum = that.$refs.carousel.activeIndex+1
                                    throw new Error("breakForEach");
                                // }else{
                                //     that.$message({showClose: true,message: '您尚未答题'});
                                // }
                            }
                        });
                    });
                } catch (e) {
                    if (e.message!="breakForEach") throw e;
                }
            },
            lastQuestion(){
                let that = this
                try {
                    that.topicList.forEach((element,index) => {
                        element.questionList.forEach((ele,i) => {
                            let first = JSON.stringify(that.$refs.carousel.activeIndex)
                            let x = JSON.parse(first)
                            if(ele.serial == x+1){
                                // 切换上一题，结束下一题音频
                                if(that.topicType.indexOf(ele.questionDto.typeCode)!=-1){eval("that.$refs.topicRef" +(ele.bId))[0].endAudio()}
                                // 如果是最后一题提交
                                that.$refs.carousel.prev()
                                that.buttonNum--
                                throw new Error("breakForEach");
                            }
                        });
                    });
                } catch (e) {
                    if (e.message!="breakForEach") throw e;
                }
            },
            // 指定跳转
            flashTag(i){
                let that = this
                if(that.$refs.carousel.activeIndex != Number(i-1)){
                    that.topicList.forEach((element,index) => {
                        element.questionList.forEach((ele,c) => {
                            let first = JSON.stringify(that.$refs.carousel.activeIndex)
                            let x = JSON.parse(first)
                            if(ele.serial == x+1){
                                // 切换上一题，结束下一题音频
                                if(that.topicType.indexOf(ele.questionDto.typeCode)!=-1){eval("that.$refs.topicRef" +(ele.bId))[0].endAudio()}
                                that.$refs.carousel.activeIndex = Number(i-1)
                                that.buttonNum = i
                            }
                        });
                    });
                }
            },
            exit(){
                let that = this
                let outTitle = '当前填报正在进行中，请问是否退出填报？'
                let maxNumber = Object.keys(that.$store.getters.is_isZip_zipLoading).length
                if(maxNumber>0)
                outTitle = '检测到有文件正在上传，离开填报页面将中断上传!!!'
                that.$confirm(`${outTitle}`, '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '离开',
                    cancelButtonText: '继续答题',
                    type:'warning',
                })
                .then(() => {
                    if(maxNumber>0)that.judgeZipLoading()
                    window.clearTimeout(that.timer);
                    window.clearTimeout(that.time5min);
                    window.clearInterval(that.youxunTimeout);
                    that.preventTimeout && window.clearTimeout(that.preventTimeout)
                    window.sessionStorage.removeItem('toLastUuid')
                    if(sessionStorage.getItem('orgId')){//测评
                        that.$router.push({
                            path: `/${sessionStorage.getItem('orgId')}/examList`,
                        })
                    }else{
                        that.$router.push({
                            path: '/myExamList'
                        })
                    }
                })
                .catch(action => {});
            },
            okYesSubmit(){
                let that = this
                if(that.preventClickTime){
                    that.$message('点击频繁！')
                    return
                }
                that.preventClickTime = true
                that.preventTimeout = window.setTimeout(function(){
                    that.preventClickTime = false
                    window.clearTimeout(that.preventTimeout)                    
                },4000)
                that.tojiData('yg',function(jsonData,jsonDataJudge,flages){
                    //不在判断是否答题，全展示
                    // that.$refs.examAllOk.open(jsonData,jsonDataJudge,flages)
                    
                    if(flages.length>0){//有未答的题
                        that.$confirm('材料提交不完整，请检查完整后再次提交', '系统提示', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '继续',
                            cancelButtonText: '返回',
                            showConfirmButton:false,
                            type:'warning',
                        })
                        .then(() => {})
                        .catch(() => {})
                        // that.$refs.examAllOk.open(jsonData,jsonDataJudge,flages)
                    }else{//无未答的题
                        that.centerDialogVisible = true
                    }
                })
            },
            // 存在未答的题 强制交卷
            mandatoryAjax(){
                this.centerDialogVisible = true
            },
            editAnswerType($event){
                eval("this.$refs.topicRef" +($event.paperQuestionId))[0].editAnswerType($event)
            },
            // 自动提交考试结果
            autoSubmit(jsonDataTimeTo){
                let that = this
                that.$nextTick(()=>{
                    that.tojiData(null,function(jsonData,jsonDataJudge,flages){
                        that.mandatorySubmit(jsonData)
                    })
                })
            },
            submit(){
                let that = this
                that.$refs.examAllOk.offDialog()
                that.preventDoubles = true
                setTimeout(function () {
                    that.preventDoubles = false
                },1000)
                that.centerDialogVisible = false
                that.tojiData(null,function(jsonData,jsonDataJudge,flages){
                    that.mandatorySubmit(jsonData)
                })
            },
            tojiData(mode,callback){
                let that = this
                mode = mode || 'ks'
                let jsonData = []//考试数据
                let jsonDataJudge = [] //判断答题是否完整
                let questionInfo = []
                that.topicList.forEach((element,index) => {
                    element.questionList.forEach((ele,i) => {
                        if(ele.questionDto.typeCode != 777){
                            jsonData.push(eval("that.$refs.topicRef" +(ele.bId))[0].processTheData())
                            jsonDataJudge.push(ele.questionDto.typeCode)
                            questionInfo.push(ele)
                        }
                    });
                });
                let flages = []
                flages = utils.completeAllQuestions(jsonData,jsonDataJudge,questionInfo,mode)//是否有未答的题
                return callback(jsonData,jsonDataJudge,flages)
            },
            //无未答的题或强制交卷
            mandatorySubmit(jsonData){
                let that = this
                if(that.allData.reviewType==1){//1=前台自动阅卷 2=后台阅卷
                    that.grade(jsonData,that.allData)
                }else{
                    that.submitReally(that,that.automatic(that,jsonData,that.allData),that.allData.reviewType)
                }
            },
            // 自动阅卷
            grade(jsonData,dataAll){
                let that = this
                jsonData = that.automatic(that,jsonData,dataAll)
                //计算总分
                let totalScore = 0
                jsonData.forEach((item,x) => {
                    totalScore += Number(item.score)
                })
                //-1=未通过 1=通过
                if(totalScore>=dataAll.passScore){
                    that.submitReally(that,jsonData,1)
                }else{
                    that.submitReally(that,jsonData,-1)
                }
            },
            // 10 11 12 50 单选 多选 判断 填空 自动计算分数
            automatic(that,jsonData,dataAll){
                dataAll.groupList.forEach((ele,i) => {
                    ele.questionList.forEach((son,index) => {
                        jsonData.forEach((item,x) => {
                            if((that.keYimarking.indexOf(son.questionDto.typeCode)!=-1)&&item.questionId==son.questionDto.bId&&item.paperQuestionId==son.bId){
                                switch(son.questionDto.typeCode){
                                    case '10':
                                        son.questionDto.detailInfo.detailsList.forEach(opt => {
                                            switch(opt.isAnswer){
                                                case '1':
                                                    if(item.selectIds == opt.bId){
                                                        item.score = son.score
                                                    }else{item.score = 0}
                                                    break;
                                                default:
                                                    break;
                                            }
                                        });
                                        break;
                                    case '11':
                                        let num = 0;
                                        let success = true
                                        let selectIds_arr = utils.deepClone2(item.selectIds)
                                        selectIds_arr = item.selectIds? item.selectIds.split(','):[]
                                        selectIds_arr = selectIds_arr.map(Number);
                                        son.questionDto.detailInfo.detailsList.forEach(opt => {
                                            switch(opt.isAnswer){
                                                case '1':
                                                    num++;
                                                    if(selectIds_arr.indexOf(opt.bId)==-1){
                                                        success = false
                                                    }
                                                    break;
                                                default:
                                                    break;
                                            }
                                        });
                                        if(selectIds_arr.length!=num){
                                            success = false
                                        }
                                        if(success){
                                            item.score = son.score
                                        }else{
                                            item.score = 0
                                        }
                                        break;
                                    case '12':
                                        son.questionDto.detailInfo.detailsList.forEach(opt => {
                                            switch(opt.isAnswer){
                                                case '1':
                                                    if(item.selectIds == opt.bId){
                                                        item.score = son.score
                                                    }else{item.score = 0}
                                                    break;
                                                default:
                                                    break;
                                            }
                                        });
                                        break;
                                    case '50':
                                        let successe = true
                                        son.questionDto.detailInfo.blankList.forEach((opt,s) => {
                                            if(JSON.stringify(opt) != JSON.stringify(item.fillBlankVal.split('#@#')[s])){
                                                successe = false
                                            }
                                        })
                                        if(successe){
                                            item.score = son.score
                                        }else{
                                            item.score = 0
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        });
                    });
                });
                return jsonData
            },
            submitReally(that,jsonData,reviewType){
                that.getNetWorkTime((time)=>{
                    let json = {
                        uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                        paperId:that.allData.bId,
                        startDateVal:that.firstStartDateVal,
                        endDateVal:time,
                        examStatus:reviewType==2?null:reviewType,//【null=需后台阅卷 -1=未通过 1=通过】
                        paperType:sessionStorage.getItem('orgId')? 'ACG':'USER_SIGN',// USER_SIGN=报名试卷(默认) ACG=音基试卷
                        paperVer:that.allData.paperVer,
                        userSignId:that.$route.query.userSignId,//用户报名主键id
                        switchNum:that.switchNum,//进入考试后切换浏览器标签数
                        userPaperUuid:that.uuid1,
                        chongChuan:that.$route.query.bohuiChongchuan==1?1:null,//[仅国音用]是否可重传 1=重传
                        jsonData:JSON.stringify(jsonData),
                    }
                    that.storageJson = json
                    that.storeLocallyAfter()//将打分同步到本地存储
                    /**
                     * 先备份数据OSS,
                     * 然后上传试卷
                    */
                    that.downloadToLocal()//备份到本地
                    
                    that.submitTheCircle = true
                    that.percenStatus = '待上传'
                    setTimeout(function(){
                        that.uploadTheTestPaper(json)
                    },6000)
                    that.upJsonDataOss(json,that.allData.bId)
                })
            },
            // json下载到本地txt
            downloadTXT(content, fileName, contentType) {
                this.$store.commit('get_isSwitch',true)
                var a = document.createElement("a");
                a.setAttribute('target', '_blank');
                var file = new Blob([content], {type: contentType});
                // 并上传一份到oss
                this.upDownloadTXT(content)
                a.href = URL.createObjectURL(file);
                a.download = fileName;
                a.click();
            },
            upDownloadTXT(content){
                let files = new File([content], `${process.env.ANSWER_OSS}/${this.allData.bId}/${this.$route.query.userSignId}/answer_encrypt.txt`, {type: 'text/plain', lastModified: Date.now()})
                os.uploadHttp(files,function(e,file){
                    console.log('TXT_oss',e)
                },'ossType')
            },
            // 下载答题数据在本地
            downloadToLocal(){
                /**
                 * 文件名命名规则:
                 * 试卷名称_手机号_评测_开始答题时间.txt
                 * 试卷名称_登录账号_考级_开始答题时间.txt
                 */
                let fileName;
                let reg = "/[-_:\\\s]/g";
                if(this.storageJson && this.storageJson.paperType == 'USER_SIGN'){
                    fileName = `填报数据删除可能影响填报结果_${this.allData.name}_${this.$route.query.idCardNo}_${this.storageJson.paperType}_${this.storageJson.startDateVal.replace(eval(reg),'')}.txt`
                }else{
                    fileName = `填报数据删除可能影响填报结果_${this.allData.name}_${JSON.parse(this.usermsg).account}_${this.storageJson.paperType}_${this.storageJson.startDateVal.replace(eval(reg),'')}.txt`
                }
                let file = utils.deepClone2(this.storageJson)
                let keys = 1234567890123456;
                let aesTo = AES.encrypt(JSON.stringify(file),keys)
                this.downloadTXT(aesTo, fileName, 'text/plain');
            },
            uploadTheTestPaper(json){
                let that  = this
                that.theirPapers = 0
                that.percenStatus = '上传中'
                wsMethod.wsSend216(that)
                that.$axios.post('/paper/saveUserPaper',json,res => {
                    var v = res.data
                    if (v.code == 0) {
                        wsMethod.wsSend217(that)
                        that.$notify({
                            title: v.msg,
                            type: 'success'
                        });
                        that.theirPapers = 100
                        that.percenStatus = '已上传'
                        window.sessionStorage.removeItem('toLastUuid')
                        that.isSubmit = true
                    } else {
                        wsMethod.wsSend218(that)
                        that.percenStatus = '上传失败'
                    }
                })
            },
            upJsonDataOss(jsonData,paperId){
                let that = this;
                let bold = JSON.stringify(jsonData)
                let idNum;
                if(sessionStorage.getItem('orgId')){//试卷id/用户id_考试开始时间.txt
                    let reg = "/[:-]/g";
                    let myregex = eval(reg);
                    idNum = Number(that.$base64.decode(window.localStorage.getItem('uid-web')))+'_'+that.firstStartDateVal.replace(myregex,'').replace(' ','')
                }else{//试卷id/报名id/answer.txt
                    idNum = that.$route.query.userSignId+'/answer'
                }
                let files = new File([bold], `${process.env.ANSWER_OSS}/${paperId}/${idNum}.txt`, {type: 'text/plain', lastModified: Date.now()})
                that.backupStatus = '上传中'
                os.uploadHttp(files,function(e,file){
                    console.log(e)
                    if(e){
                        that.backupStatus = '已上传'
                        if(sessionStorage.getItem('orgId')){
                            setTimeout(function(){
                                that.saveUserPaperUrloss(e,jsonData.endDateVal)
                            },1500)
                        }
                    }
                    else{
                        that.backupStatus = '上传失败'
                        store.commit('get_textRess',Number(0))
                    }
                },'ossType')
            },
            successExam(){
                let that = this;
                that.submitTheCircle = false
                let pName = that.$route.query.paperName
                if((pName=="音乐测评"||pName=="中央美术学院中国画专业专业创作"||pName=="央美中国画专业专业创作")){
                    that.$router.push({
                        path: `/${sessionStorage.getItem('orgId')}/resultsShow`,
                        query: {
                            id:that.allData.bId,
                            endDateVal:that.storageJson.endDateVal
                        }
                    })
                }else{
                    localStorage.getItem('ceping-'+that.uid+'-'+that.allData.bId)? localStorage.removeItem('ceping-'+that.uid+'-'+that.allData.bId):''
                    // 国音 勾选协议记录 删除local
                    const guoyinXieyi = `gyAm-${Number(that.$base64.decode(window.localStorage.getItem('uid-web')))}`
                    let agreeLocValue = window.localStorage.getItem(guoyinXieyi)?JSON.parse(window.localStorage.getItem(guoyinXieyi)):''
                    if(agreeLocValue[that.$route.query.bId]){
                        delete agreeLocValue[that.$route.query.bId]
                        if(JSON.stringify(agreeLocValue)=='{}')
                        window.localStorage.removeItem(guoyinXieyi)
                        else
                        window.localStorage.setItem(guoyinXieyi,JSON.stringify(agreeLocValue))
                    }

                    if(sessionStorage.getItem('orgId')){//测评
                        that.$router.push({
                            path: `/${sessionStorage.getItem('orgId')}/examList`,
                        })
                    }else{
                        that.$router.push({
                            path: '/myExamList',
                            query:{tab:2,del:10}
                        })
                    }
                }
            },
            // 重新交卷
            axjsJj(){
                this.uploadTheTestPaper(this.storageJson)
            },
            // 重新备份数据
            axjsOss(){
                let that = this
                that.upJsonDataOss(that.storageJson,that.allData.bId)
            },
            onChange(currentTime,oldIndex){
                // console.log(`当前索引：${currentTime}, 原索引：${oldIndex}`)
            },
            dealExamMin(v){
                // return utils.formateSeconds(v)
                return utils.fmtCountdown(v)
            },
            // 每5分钟获取服务器时间
            setTimer5Minutes(){
                let that = this
                that.getNetWorkTime((time)=>{
                    let t = (that.ENDTIME - Date.parse(new Date(time.replace(/-/g, "/"))))/1000; // 剩余的毫秒数
                    that.examMinTime = t
                    that.time5min = window.setTimeout(function () {that.setTimer5Minutes();}, 300000);
                    that.timer && window.clearTimeout(that.timer);
                    that.setTimer()
                })
            },
            setTimer(){
                let that = this
                if(that.examMinTime > 0) {
                    that.examMinTime--;
                    that.timer = window.setTimeout(function () {that.setTimer();}, 1000);
                }else{
                    that.timer && window.clearTimeout(that.timer);
                    that.time5min && window.clearTimeout(that.time5min);
                    that.examMinTime = 0
                    // 超时提示
                    that.tojiData(null,function(jsonData,jsonDataJudge,flages){
                        that.$refs.examTimeTo.open(jsonData,jsonDataJudge,flages)
                    })
                    // 结束掉播放的音频
                    that.topicList.forEach((element,index) => {
                        element.questionList.forEach((ele,i) => {
                            let first = JSON.stringify(that.$refs.carousel.activeIndex)
                            let x = JSON.parse(first)
                            if(ele.serial == x+1){ 
                                if(that.topicType.indexOf(ele.questionDto.typeCode)!=-1){eval("that.$refs.topicRef" +(ele.bId))[0].endAudio()}
                            }
                        })
                    })
                }
            },
            // 本地存储
            storeLocally(){
                let that = this
                let storageData = []
                that.topicList.forEach((element,index) => {
                    element.questionList.forEach((ele,i) => {
                        storageData.push({
                            submitNum:eval("that.$refs.topicRef" +(ele.bId))[0].getSubmitNum(),
                            playss:eval("that.$refs.topicRef" +(ele.bId))[0].getPlayss(),
                            obj:eval("that.$refs.topicRef" +(ele.bId))[0].processTheData()
                        })
                    });
                });
                window.localStorage.setItem(
                    'ceping-'+that.uid+'-'+that.allData.bId
                    ,JSON.stringify({
                        firstStartDateVal:that.firstStartDateVal,
                        time:that.examMinTime,
                        switchNum:that.switchNum,
                        dataList:storageData,
                    })
                )
                // 触发答题卡脉冲
                that.tojiData('yg',function(jsonData,jsonDataJudge,flages){
                    that.$refs.answerSheet.artery(jsonDataJudge,flages)
                })
            },
            // 提交时打完分在存储一遍，展示数据使用
            storeLocallyAfter(){
                let that = this
                let storageData = []
                let num = 0
                that.topicList.forEach((element,index) => {
                    element.questionList.forEach((ele,i) => {
                        storageData.push({
                            submitNum:eval("that.$refs.topicRef" +(ele.bId))[0].getSubmitNum(),
                            playss:eval("that.$refs.topicRef" +(ele.bId))[0].getPlayss(),
                            obj:JSON.parse(that.storageJson.jsonData)[num]
                        })
                        num++;
                    });
                });
                window.localStorage.setItem(
                    'ceping-'+that.uid+'-'+that.allData.bId
                    ,JSON.stringify({
                        firstStartDateVal:that.firstStartDateVal,
                        time:that.examMinTime,
                        switchNum:that.switchNum,
                        dataList:storageData,
                    })
                )
            },
            // 3倒计时
            come3Time(){
                let that = this
                that.countdownDialog = true
                let threeTime = window.setInterval(function () {
                    that.threeSeconds--;
                    if(that.threeSeconds<=0){
                        window.clearInterval(threeTime)
                        that.countdownDialog = false
                        setTimeout(function(){
                            that.threeSeconds = 3
                        },100)
                    }
                },1000)
            },
            //oss成功后备份url
            saveUserPaperUrloss(e,tStart){
                let that  = this
                that.$axios.post('/paper/saveUserPaperUrl',{
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                    paperId:that.allData.bId,
                    startDateVal:tStart,
                    url:e,
                    userSignId:that.$route.query.userSignId
                },res => {
                    var v = res.data
                    if (v.code == 0) {
                        that.$notify({
                            title: v.msg,
                            type: 'success'
                        });
                    } else {
                        that.$message.error(v.msg);
                    }
                })
            },
            examYxInfo(){
                this.$refs.youXunDrops.open()
            },
            //接入优巡监控状态
            getLoginStatus(){
                let that = this
                that.youxunTimeout && window.clearInterval(that.youxunTimeout)
                that.youxunTimeout = window.setInterval((function target(){
                    loginStatus(
                        that.$route.query.youXunExamNum,
                        that.$route.query.ticketNum,
                        (response)=>{
                            if(response.data&&response.data.data){
                                that.networkError = false
                                // 之前1个/2个为true，请求返回都是false时弹框
                                if(
                                    that.examMinTime>180&&
                                    (that.appLogin||that.exeLogin)&&
                                    (!response.data.data.second&&
                                     !response.data.data.first)
                                )
                                that.$refs.youXunDrops.open(true)
                                that.appLogin = response.data.data.second,
                                that.exeLogin = response.data.data.first
                            }else{
                                if(response&&response.message&&response.message=='Network Error'){//无网
                                    that.networkError = true
                                }
                            }
                        }
                    )
                    return target
                })(),30000)
            },
            // 判断是否有网络
            isNetWork(){
                let that = this
                that.isNetWork = window.setInterval((function chongIsNet(){
                    utils.onLineNetWork(function(flag) {
                        if (flag) {
                            that.networkError = false
                        } else {
                            that.$message.error('网络错误！');
                            that.networkError = true
                        }
                    })
                    return chongIsNet
                })(),30000)
            },
            // 事件反馈接口
            buriedPointEventAdd(){
                let that = this
                let oSInfo = systemCheck.getMobileSystemInfo()
                let browserInfo= systemCheck.getExplorerVersion()
                that.$axios.post('/event/add',{
                    appOpDate:Date.parse(new Date()),
                    opCode:'join',
                    paperId:that.$route.query.bId,
                    userPaperUuid:that.uuid1,
                    userSignId:that.$route.query.userSignId,//报名id 获取抽题正式考试的题
                    clientName:browserInfo.split(' ')[0],	//户端软件名称
                    clientVer:browserInfo.split(' ')[1],	//客户端软件版本
                    clientSys:oSInfo.split(' ')[0],	//客户端系统	
                    clientSysVer:oSInfo.split(' ')[1],	//客户端系统版本	
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    var v = res.data
                    if (v.code == 0) {}else{
                       console.log('失败')
                    }
                })
            },
            // 推出考试页面停止文件上传和删除数据
            judgeZipLoading(){
                let arr1 = Object.keys(this.$store.getters.is_isZip_zipLoading)
                for (let t = 0; t < arr1.length; t++) {
                    (function (t, data) {   // 注意这里是形参
                        let closeZip = window.setTimeout(function () {
                            let serial = data.split('doc_')[1]
                            if(serial)
                            zipOss.abortMultipartUpload(serial)
                            window.clearTimeout(closeZip)
                        }, 1000 * (t+1));	// 还是每秒执行一次，不是累加的
                    })(t, arr1[t])   // 注意这里是实参，这里把要用的参数传进去
                }
                this.$store.commit('get_deleteAllZip')
            },
            copyClick(){
                this.$prompt('请输入特定的的操作密码？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputType:'password',
                    inputErrorMessage: '密码不能为空',
                    inputValidator: (value)=>{
                        if(value.trim().length < 1){
                            return '输入不能为空'
                        }
                    },
                    beforeClose: (action, instance, done)=>{
                        if(action == 'confirm'){
                            let value = instance.inputValue
                            if(value != '123457'){
                                this.$message.error('操作密码输入错误！')
                            }else{
                                this.$refs.promptMailbox.open()
                                done()
                            }
                        }else{
                            done()
                        }
                    },
                    callback: function (action, instance) {}
                })
            },
            addUdeskCn(){
                (function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})
                (window,document,"script","https://wap-sz.aitestgo.com/showOnly/udeskApi.js?ut=1709691420931","ud");
                ud({
                    "code": "2f0k97h2",
                    "link": "https://ata.s2.udesk.cn/im_client_nocdn/?web_plugin_id=61482",
                    "onlineText": "客服",
                    "offlineText": "留言",
                    "pos_flag": "hrm",
                });
                this.$nextTick(()=>{
                    let kFu = document.getElementById('udesk_container')
                    if(kFu)
                    kFu.style.display = "inherit"
                })
            },
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .sheetClass{
        position: absolute;
        top: 50px;
        left: 0;
        bottom: 0px;
        width: 225px;
        border-right: 5px solid #E8EBF2;
    }
    .container-skin{
        position: absolute;
        top: 50px;
        right: 0;
        bottom: 0;
        width: 1024px;
        float: right;
    }
    .hat{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 50px;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #EDEEED;
        box-sizing: border-box;
        padding: 0 20px 0 10px;
        display: -webkit-flex;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;

        .header{
            order: 100;
            flex-grow: 1;
            font-size: 19px;
            font-weight: bold;
            color: #000;
            text-align: left;
            box-sizing:border-box;
            padding-right: 10px;
            line-height:20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .monitorDiv{
            order: 5;
            font-size: 13px;
            color: #000;
            flex-shrink: 0;
            p{
                display: inline-block;
                margin-left: 6px;
            }
            img{
                width: 25px;
                vertical-align: middle;
            }
        }
        .examYxinfo{
            order: 4;
            margin: 0 10px;
            padding: 7px 10px !important;
        }
        .iconMail{
            order: 3;
            cursor: pointer;
            box-sizing: border-box;
            padding: 0 10px;
            img{
                height: 27px;
                width: 27px;
                margin-top:6px;
            }
        }
        .examTime{
            order: 2;
            flex-shrink: 0;
            font-size: 18px;
            color: red;
            box-sizing: border-box;
            padding: 0 10px;
        }
        .exit{
            order: 1;
            flex-shrink: 0;
            background-color: #31C4FE;
            border: none;
            font-size: 14px;
            color: #fff;
            font-weight: bold;
            img{
                height: 10px;
            }
        }
        .bLeftLine{
            border-left: 1px solid;
            border-right: 0px;
            border-top: 0px;
            border-bottom: 0px;
            border-image: -webkit-linear-gradient(transparent,#E5E5E5,transparent) 0 1 0;
            border-image: -moz-linear-gradient(transparent,#E5E5E5,transparent) 0 1 0;
            border-image: -o-linear-gradient(transparent,#E5E5E5,transparent) 0 1 0;
            border-image: linear-gradient(transparent,#E5E5E5,transparent) 0 1 0;
        }
    }
    .main{
        position: absolute;
        top: 5px;
        bottom: 50px;
        left: 20px;
        right: 20px;
    }
    .mainStyle{
        height: 100%;
        width: 100%;
        position: relative;
    }
    .carouselItem{
        height: 100%;
        width: 100%;
        .el-carousel__container{
            height: 100% !important;
        }
    }
    .footer{
        position: absolute;
        bottom: 0;
        height: 50px;
        left: 0;
        right: 0;
        width: 100%;
        box-sizing: border-box;
        border-top: 1px solid #EDEEED;
        padding-top: 4.5px;
        .sub{
            background: rgb(0, 75, 180);
            color: #FFF;
            font-size: 15px;
        }
        .upSub{
            width: 20%;
            background-color: #1C81FE;
            color: #FFF;
            font-size: 15px;
        }
    }
</style>
<style>
    .carouselItem .el-carousel__container{
        height: 100% !important;
    }
    .exitExam .el-dialog__body{
        padding: 25px 25px 15px !important;
        text-align: center !important;
        font-size: 16px !important;
        color: #000 !important;
    }
    .exitExam .el-dialog{
        width: 450px !important;
        height: 230px !important;
    }
    .switchingBrowsers .el-dialog{
        width: 500px !important;
        height: 202px !important;
    }
    .switchingBrowsers .el-dialog .el-dialog__header{
        background-color: #fff;
    }
    .switchingBrowsers .el-dialog .el-dialog__body{
        padding: 20px 20px 40px 20px !important;
    }
    .switchingBrowsers .el-dialog .el-dialog__header .el-dialog__title {
        color: #000;
        font-weight: bold;
    }
    .exitExam .el-dialog .el-dialog__header{
        display: none;
    }
    .exitExam .el-dialog__body{
        padding: 60px 25px 40px !important;
    }
    .exitExam .el-dialog__footer{
        padding: 20px 20px 30px !important;
    }

    .countdownBox .el-dialog{
        width: 100% !important;
        height: 100%;
        background: transparent !important;
        border: 0px !important;
        box-shadow: none !important;
    }
    .countdownBox .el-dialog .el-dialog__header{
        display: none !important;
    }
    .countdownBox .el-dialog__body{
        height: 100%;
        padding: 0 !important;
        background: transparent;
        position: relative;
    }
    .countdownBox .el-dialog__body .countdownBox-con{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 400px;
        height: 200px;
    }
    .countdownBox p{
        color: #fff;
        font-weight: bold;
        font-size: 30px;
        text-align: center;
    }
    .countdownBox p:nth-child(1){
        font-size: 60px;
        margin-bottom: 25px;
    }

    .lastBox .el-dialog{
        width: 490px !important;
        height: 290px;
    }
    .lastBox .el-dialog .el-dialog__header{
        /* display: none !important; */
        background: #1D4BB0 !important;
    }
    .lastBox .el-dialog .el-dialog__header .el-dialog__title{
        font-size: 18px !important;
        font-weight: bold !important;
    }
    .lastBox .el-dialog__body{
        height: 100%;
        padding: 0 !important;
        background: transparent;
        position: relative;
    }
    .lastBox .el-dialog__body .lastBox-con{
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        padding: 15px;
    }
    .lastBox .lastBox-con .hader{
        height: 50px;
        text-align: center;
        line-height: 50px;
        font-size: 19px;
        margin-bottom:34px;
        font-weight: bold;
        border-bottom: 2px dotted #000;
    }
    .lastBox .lastBox-con .styleUpdate{
        height: 40px;
        width: 100%;
        margin-top: 10px;
        padding-top: 10px;
        font-size: 15px;
        box-sizing: border-box;
    }
    .lastBox .lastBox-con .styleUpdate .stu-name{
        float: left;
        width: 18%;
        height: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
    }
    .lastBox .lastBox-con .styleUpdate .stu-load{
        float: left;
        width: 57%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 10px;
        margin-top: 3px;
    }
    .lastBox .lastBox-con .styleUpdate .stu-last{
        float: left;
        width: 20%;
        height: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
    }
    .lastBox .lastBox-con .styleUpdate .stu-agian{
        float: right;
        width: 17%;
        height: 100%;
    }
    .lastBox .lastBox-con .downTxt{
        position: relative;
        width: 76%;
        height: 25px;
        font-size: 12.5px;
        text-align: center;
    }
    .lastBox .lastBox-con .downTxt .downTxt_btu{
        position: absolute;
        /* left: 4px; */
        bottom: 0%;
        font-size: 13px;
    }
    .lastBox .lastBox-con .food{
        height: 50px;
        /* border-top: 2px dotted #000; */
        text-align: center;
        margin-top: 18px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding-top: 14px;
    }
    .lastBox .lastBox-con .succExam{
        color: #FFF;
        font-size: 17px;
        width: 60%;
        padding: 9px;
    }
    .importentTitle .el-notification__title{
        color:red !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/exam/problem.vue